import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/mapaAT/step1';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { AttributionFromMAPA } from '../../models/AttributionFromMAPA';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {

  @Input() attributionFromMAPA: AttributionFromMAPA;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  public step1 = new Step1();

  constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService) { }

  ngOnInit(): void { }

  public getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA';
  }
}
